import React from 'react';

const TermsAndConditions = () => (
    <>
      <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
        <h1>Terms and Conditions for Delivery</h1>

        <ol>
          <li>Please make sure that your box is labelled by the driver and collect your tracking receipt.</li>
          <li>Please write down the collection reference number provided by us on the box.</li>
          <li>Please write down the sender and receiver details on the box.</li>
          <li>Please make a list of all items and put them inside the box.</li>
          <li>Please take a picture of the box once it is packed.</li>
          <li>
            For pick-up, the maximum weight allowed is 30kg per box of chargeable weight (gross weight or volume
            weight), whichever is higher. In the boxes, simply type in the dimensions of the package in centimetres:
            width x length x Height in centimetres / 5000 = volumetric weight in kilograms (only for air freight).
          </li>
          <li>We need the receiver's ADHAR card, passport, NIC, or driving license for the customs clearance.</li>
          <li>Banned items as per the IATA list are not allowed.</li>
          <li>All shipments are accepted, subject to terms and conditions.</li>
          <li>
            The sender will be required to prepare an itemized list. It will be the sender's responsibility for any missing
            items if they're not mentioned on the list or miss declared.
          </li>
          <li>All non-document items are subject to inspection.</li>
          <li>Airline Company Terms and Conditions will be applied to all shipments.</li>
          <li>For pick-up and delivery, the terms and conditions of the local pick-up courier company will be applied.</li>
          <li>The sender will be responsible for any incorrect declaration.</li>
          <li>Customs duty is not included. For any customs duty, the customer is liable to pay.</li>
          <li>
            All deliveries are subject to airline or vessel weather conditions, customs clearance, and flight or vessel
            schedules or delays.
          </li>
          <li>
            For delivery, it takes air cargo 10 to 12 working days for main cities and 1 to 4 extra days for remote
            locations. There is no guarantee for damage or breakage during transit. Separate insurance must be taken.
          </li>
          <li>
            For delivery, it takes sea cargo 60 to 90 working days for main cities and 7 extra days for remote locations.
            There is no guarantee for damage or breakage during transit. Separate insurance must be taken.
          </li>
          <li>Once the receiver accepts the parcel and signs, Teeparam Traders will not be responsible for any claims.</li>
          <li>All Prices are subject to change without prior Notice.</li>
          <li>Teeparam Traders maximum Liability is up to US $ 50.</li>
          <li>
            When the driver arrives for the pickup, please keep the box ready for him to collect, with the sender and
            receiver details clearly written on the box.
          </li>
          <li>
            Please don't send shipments for commercial purposes. We are not responsible for the commercial goods sent by
            the customer without our knowledge. For any customs duty, the customer is liable to pay.
          </li>
          <li>You do not need to pay anything to the driver for pickup; we will provide you with the bank details for the payment.</li>
          <li>
            We do not accept the parcel if the value of the items exceeds 100 pounds. If customers desire to ship things
            worth more than 100 pounds, separate insurance should be taken; if not, Teeparam is not liable for any
            missing or damaged items.
          </li>
          <li>
            If the given receiver phone number is invalid or the wrong number, it may affect the delivery time. Teeparam
            is not responsible for that. If the receiver address is wrong, 25 pounds will be charged.
          </li>
          <li>
            Please note: If the parcel items are liable for prohibited items or Illegal goods, it will be your
            responsibility to handle these things accordingly.
          </li>
        </ol>

        <p>
          By accepting this, you agree to these terms and acknowledge that Teeparam is not liable for any such issues
          that may come after dispatch.
        </p>
      </div>
      <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
        <h1>Air Cargo Delivery</h1>

        <h3>1. Delivery Timeline</h3>
        <p>
          Air cargo delivery typically takes 7 to 10 working days. This timeline is subject to factors beyond the company's
          control, such as customs clearance, weather conditions, or other unforeseen circumstances.
        </p>

        <h3>2. Damage or Breakage During Transit</h3>
        <ul>
          <li>
            While the company takes reasonable care in handling goods, no guarantee is provided against damage or
            breakage during transit.
          </li>
          <li>
            In the event of damage or breakage:
            <ul>
              <li>
                <strong>Maximum Compensation:</strong> The Company is prepared to offer compensation up to a maximum of
                £100, depending on the level of damage or breakage, and only after completing an investigation.
              </li>
              <li>
                <strong>Notification Requirement:</strong> Any enquiry regarding damage or breakage must be made at the
                time the parcel is accepted by the recipient. Notification must be supported by evidence, such as
                photographs or a signed delivery receipt noting the damage.
              </li>
              <li>
                <strong>Delayed Notification:</strong> If the recipient fails to raise an enquiry about damage or
                breakage at the time of acceptance, the company shall not be liable to provide any compensation.
              </li>
            </ul>
          </li>
          <li>
            <strong>Insurance Option:</strong> Customers who require coverage exceeding the £100 compensation limit must
            arrange for additional insurance at their own expense.
          </li>
        </ul>

        <h3>3. Consumer Rights and Reasonable Care</h3>
        <p>
          These terms do not affect the customer's rights under the Consumer Rights Act 2015, including the right to
          expect goods to arrive in a satisfactory condition. Customers should inspect goods within a reasonable timeframe
          and notify the company of any issues promptly.
        </p>

        <h1>Sea Cargo Delivery</h1>

        <h3>1. Delivery Timeline</h3>
        <p>
          Sea cargo delivery typically takes 7 to 9 weeks, subject to customs clearance and other external factors.
        </p>

        <h3>2. Damage or Breakage During Transit</h3>
        <ul>
          <li>
            The company will not be held responsible for damage or breakage during transit unless otherwise specified.
          </li>
          <li>
            In the event of damage or breakage:
            <ul>
              <li>
                <strong>Maximum Compensation:</strong> Compensation of up to £100 may be offered, subject to the level of
                damage or breakage, following an investigation.
              </li>
              <li>
                <strong>Notification Requirement:</strong> Enquiries regarding damage or breakage must be made at the
                time the parcel is accepted by the recipient, supported by evidence such as photographs or a delivery
                receipt noting the damage.
              </li>
              <li>
                <strong>Delayed Notification:</strong> If an enquiry is made after the recipient accepts the parcel, the
                company will not be liable to provide any compensation.
              </li>
            </ul>
          </li>
          <li>
            <strong>Insurance Option:</strong> Customers requiring coverage beyond the £100 compensation limit must
            purchase separate insurance at their own cost.
          </li>
        </ul>

        <h3>3. International Shipping Regulations</h3>
        <p>
          For sea cargo shipments, liability will be governed by applicable international conventions, including but not
          limited to the Hague-Visby Rules, where relevant. These rules may impose minimum liability obligations on the
          company, which cannot be excluded by these terms.
        </p>

        <h3>4. Reasonable Care and Consumer Rights</h3>
        <p>
          These terms do not override the customer’s statutory rights under the Consumer Rights Act 2015. Customers are
          advised to inspect goods within a reasonable timeframe and report any issues promptly.
        </p>
      </div>
      <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
        <h1>General Terms for Air and Sea Cargo</h1>

        <h3>1. Compensation Investigation Process</h3>
        <p>
          All compensation claims are subject to an investigation by the company. The customer must cooperate in
          providing evidence and information required to assess the claim. The outcome of the investigation will
          determine the level of compensation offered, if any.
        </p>

        <h3>2. Insurance Coverage</h3>
        <ul>
          <li>The company’s liability is limited to £100 per shipment unless otherwise agreed in writing.</li>
          <li>
            Customers are encouraged to purchase additional insurance for high-value goods. The company does not arrange
            such insurance and cannot be held responsible for any inadequacies in third-party coverage.
          </li>
        </ul>

        <h3>3. Fairness of Terms</h3>
        <ul>
          <li>
            These terms have been drafted in accordance with the Consumer Rights Act 2015 and the Unfair Contract Terms
            Act 1977, ensuring they are fair and reasonable.
          </li>
          <li>Any ambiguities in these terms will be interpreted in favour of the customer.</li>
        </ul>

        <h3>4. Limitation of Liability</h3>
        <p>Nothing in these terms limits or excludes liability for:</p>
        <ul>
          <li>Death or personal injury caused by the company's negligence.</li>
          <li>Fraud or fraudulent misrepresentation.</li>
          <li>
            Breach of any terms implied by the Consumer Rights Act 2015, including the obligation to deliver goods of
            satisfactory quality.
          </li>
        </ul>

        <h3>5. Jurisdiction and Governing Law</h3>
        <p>
          These terms shall be governed by and construed in accordance with the laws of England and Wales. Any disputes
          shall be subject to the exclusive jurisdiction of the English courts.
        </p>

        <h1>Handling of Complaints and Social Media Comments</h1>

        <h3>1. Complaint Resolution Process</h3>
        <ul>
          <li>
            Customers or any other parties with concerns about the company, its products, services, or any service
            received must raise their complaint directly with the company by contacting the designated representative or
            customer service team.
          </li>
          <li>
            Complaints must be lodged through the official channels provided by the company, ensuring a clear record for
            resolution purposes.
          </li>
        </ul>

        <h3>2. Restriction on Public Comments During Resolution</h3>
        <ul>
          <li>
            To ensure a fair and constructive resolution process, customers or other parties are requested not to post
            comments or information about their complaints on social media platforms while the matter is under
            investigation and resolution by the company.
          </li>
          <li>
            This policy helps prevent the dissemination of incomplete or potentially misleading information, safeguarding
            both the company and the customer from unnecessary reputational harm.
          </li>
        </ul>

        <h3>3. Post-Resolution Feedback</h3>
        <p>
          If the complaint is resolved but the customer or other party remains dissatisfied and the company decides not
          to take further action, they may share their views on social media, provided such comments are accurate and do
          not contain false or defamatory statements.
        </p>

        <h3>4. Misrepresentation and Defamation</h3>
        <ul>
          <li>
            The company reserves the right to take appropriate legal action against individuals or entities who post
            false, defamatory, or misleading statements on social media platforms about the company, its products, or
            services.
          </li>
          <li>
            Legal action may include claims for defamation or damages if such statements cause unjustified harm to the
            company's reputation or business.
          </li>
        </ul>

        <h3>5. Customer Rights and Responsibilities</h3>
        <ul>
          <li>
            This policy does not limit a customer’s statutory rights to freedom of speech under UK law. However,
            customers and other parties are reminded that under the Defamation Act 2013, statements made publicly must
            be truthful and not misleading.
          </li>
          <li>
            Inappropriate or malicious use of social media to spread false information may result in legal consequences.
          </li>
        </ul>

        <h3>6. Confidentiality</h3>
        <p>
          During the complaint resolution process, both the company and the complainant agree to maintain confidentiality
          to facilitate a fair and transparent investigation.
        </p>

        <h3>7. Jurisdiction</h3>
        <p>
          This clause is governed by the laws of England and Wales. Any disputes arising from its application will be
          subject to the exclusive jurisdiction of the English courts.
        </p>

        <h3>Key Legal Considerations Included:</h3>
        <ul>
          <li>
            The restriction on posting during resolution is framed as a request to avoid infringing on the customer's
            rights to freedom of expression.
          </li>
          <li>
            The clause emphasizes the company's right to take action under the Defamation Act 2013 if statements are
            false or defamatory.
          </li>
          <li>
            The inclusion of a clear complaint-handling process ensures fairness and strengthens the company's position
            if a dispute arises.
          </li>
        </ul>
      </div>
    </>
  );

export default TermsAndConditions;